import React from 'react';
import Common from './Common';

const Stories = () => {
    return(<>
    <Common />
    </>
    );
}
export default Stories;